//Generated File 
export default class ApprovalDecision{
	static readonly Approve = `Approve`;
	static readonly EscalateToDirectSupervisor = `EscalateToDirectSupervisor`;
	static readonly EscalateToSpecificEmployee = `EscalateToSpecificEmployee`;
	static readonly EscalateToSupervisor = `EscalateToSupervisor`;
	static readonly Reject = `Reject`;
	static readonly Return = `Return`;
	static readonly ReturnToPreviousStep = `ReturnToPreviousStep`;
	static readonly ReturnToSpecificStep = `ReturnToSpecificStep`;
}
